import * as React from "react";
import { useNavigate } from "react-router-dom";
import { Menu, LogOut, UserCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/supabase/AuthContext";

type Props = {
  onMenuClick: () => void;
};

export const Topbar: React.FC<Props> = ({ onMenuClick }) => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const displayName =
    (user?.user_metadata as any)?.full_name ||
    user?.email?.split("@")[0] ||
    "Kullanıcı";

  async function handleSignOut() {
    await signOut();
    navigate("/giris", { replace: true });
  }

  return (
    <header
      data-testid="app-topbar"
      className="sticky top-0 z-30 flex h-14 items-center justify-between border-b border-border bg-background/85 px-4 backdrop-blur-md md:px-6"
    >
      <div className="flex items-center gap-3">
        <Button
          variant="ghost"
          size="icon"
          onClick={onMenuClick}
          data-testid="topbar-menu-button"
          className="md:hidden"
          aria-label="Menüyü aç"
        >
          <Menu className="h-5 w-5" />
        </Button>
        <div className="flex items-center gap-2 md:hidden">
          <div className="flex h-7 w-7 items-center justify-center rounded-md bg-primary">
            <span className="font-serif text-sm text-primary-foreground">K</span>
          </div>
          <span className="font-serif text-sm text-foreground">
            Kartalyuvası
          </span>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <div
          data-testid="topbar-env-badge"
          className="hidden items-center gap-2 rounded-full border border-border bg-card px-3 py-1 text-[11px] text-muted-foreground sm:inline-flex"
        >
          <span className="inline-flex h-1.5 w-1.5 rounded-full bg-accent" />
          Önizleme
        </div>

        <div
          data-testid="topbar-user"
          className="flex items-center gap-2 rounded-full border border-transparent px-2 py-1 text-sm text-foreground/80"
        >
          <UserCircle2
            className="h-5 w-5 text-muted-foreground"
            strokeWidth={1.5}
          />
          <span className="hidden max-w-[180px] truncate sm:inline">
            {displayName}
          </span>
        </div>

        {user ? (
          <Button
            variant="ghost"
            size="sm"
            onClick={handleSignOut}
            data-testid="topbar-signout-button"
            className="gap-1.5"
          >
            <LogOut className="h-4 w-4" />
            <span className="hidden sm:inline">Çıkış</span>
          </Button>
        ) : null}
      </div>
    </header>
  );
};
